import React from "react";
import Select from "react-select";
import PendingIconImage from "../../../assets/media/icons/pending.png";
import IconStore from "../../Chatbot/components/IconStore";
import {CurrencyOptions} from "../../../Constants/retailer"; 
import "./index.css";

class AddBrandTokenEarning extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      title: "",
      description:"",
      token: 0,
      premier_token:"",
    };
  }

  handleInputChange = (field) => (event) => {
    this.setState({ [field]: event.target.value });
  };
  onChangePremierToken = ({ target: { value } }) => {
    const {territory} = this.props;
    let newValue = value.split(".");
    if (newValue.length > 1) {
      newValue =
        newValue.slice(0, -1).join("") + "." + newValue[newValue.length - 1];
    } else {
      newValue = value;
    }
    const countDecimals = function (number) {
      if (Math.floor(number) === Number(number)) return 0;
      return number.toString().split(".")[1].length || 0;
    };
    let number = Number(newValue.replace(/[^0-9\.]+/g, ""));
    const decimalPoints = countDecimals(newValue);
    if (decimalPoints >= 3) {
      number = number * 10;
    } else {
      number = number / Math.pow(10, 2 - decimalPoints);
    }
    this.setState({
      premier_token: `${CurrencyOptions[territory]}${number.toFixed(2)}`,
    });
  };

  onSelectImage = (icon) => {
    this.setState({ icon, showChooseIcon: false });
  };

  onRequestTask = ()=>{
    let { title,description, token, premier_token } = this.state;
    const { onAdd } = this.props;
    if(premier_token)
        premier_token = premier_token.substring(1)
    onAdd({ title,description, token,premier_token });
    this.setState({ title: "", description: "", token: 0,premier_token:"" });
  }
  checkValidation=()=> {
    let { title,description, token, premier_token } = this.state; 
    premier_token = premier_token.substring(1);
    token = parseInt(token);
    premier_token = parseFloat(premier_token);
    return title&&description&&(token||premier_token);
  }
  render() {
    const { title,description, token, premier_token } = this.state;
    const {territory} = this.props;
    return (
      <div
        className="modal fade token-earning-dialog"
        id="brand_token_earning_modal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="modal-default-fadein"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content add-token-earning-content">
            <div className="modal-header">
              <h5 className="modal-title">Add Brand Token Earning Task</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body pb-1 brand-token-earning-dialog-body">
             
              <p className="token-earning-property-title">
                Token Earning Title
              </p>
              <input
                className="form-control form-control-md form-control-alt"
                maxLength="24"
                onChange={this.handleInputChange("title")}
                value={title}
              />
              <p className="bottom-text">Max characters: 24</p>
              <p className="token-earning-property-title">
                Token Earning Description
              </p>
              <textarea
                className="form-control form-control-md form-control-alt"
                onChange={this.handleInputChange("description")}
                value={description}
              />
              <p className="token-earning-property-title">Shopping Token Value</p>
              <input
                type="number"
                placeholder="0"
                className="form-control form-control-md form-control-alt"
                onChange={this.handleInputChange("token")}
                value={token}
              />
              <p className="token-earning-property-title">Premier Token Value</p>
              <input
                type="text"
                placeholder={`${CurrencyOptions[territory]}00.00`}
                className="form-control form-control-md form-control-alt bill-price"
                onChange={this.onChangePremierToken}
                value={premier_token}
              />
              <div className="token-earning-footer">
                  <button className="btn"
                    disabled={!this.checkValidation()}
                    onClick={this.onRequestTask}
                    data-dismiss="modal">
                      Request bespoke gamification task
                   </button>
                  <p>Your account manager will<br/>respond within 24 hours.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AddBrandTokenEarning;



// WEBPACK FOOTER //
// ./src/screens/BrandTokenEarning/AddBrandTokenEarning/index.js